<template>
  <div class="w-full">
    <BaseInput
      :id="props.id"
      v-model="value"
      :invalid="showValidation && emailIsInvalid"
      :label="$t('Email')"
      type="email"
    >
      <template #icon>
        <IconWrapper v-if="showValidation">
          <ErrorIcon />
        </IconWrapper>
      </template>
    </BaseInput>
    <div
      v-if="showValidation"
      class="text-sm mt-1 text-[#EE3B3B]"
    >
      {{ $t('incorrect_email') }}
    </div>
  </div>
</template>

<script setup>
import BaseInput from '@/components/inputs/BaseInput.vue'
import IconWrapper from '@/components/inputs/ext/IconWrapper.vue'
import { computed, watch } from 'vue'
import ErrorIcon from '@/assets/icons/ErrorIcon.vue'

const props = defineProps({
  modelValue: {
    required: true,
    type: String
  },
  valid: {
    type: Boolean,
    default: false
  },
  id: {
    type: String,
    default: 'email',
    required: false
  }
})

const emit = defineEmits(['update:modelValue', 'update:valid'])

const value = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const showValidation = computed(() => value.value.length !== 0 && emailIsInvalid.value)
const emailIsInvalid = computed(
  () => value.value.length === 0 || !value.value.includes('@') || !value.value.includes('.')
)

watch(value, () => emit('update:valid', !emailIsInvalid.value), { immediate: true })
</script>
